
import { computed, ref, defineComponent, inject, watch, PropType } from "vue";
import { StoreKey } from "@/symbols";
import { Origin } from "@/interfaces/TimeEvent";
import Caption from "@/interfaces/Caption";

export default defineComponent({
  name: "SubtitleElement",

  props: {
    cue: {
      type: Object as PropType<Caption>,
      required: true
    }
  },

  setup(props) {
    const store = inject(StoreKey);
    if (!store) {
      throw new Error(`Could not resolve ${StoreKey.description}`);
    }
    const htmlElement = ref<HTMLElement>();

    const isInEditMode = computed(() => store.state.isInEditMode);
    const isActive = computed(() => store.state.currentCue.id === props.cue.id);

    watch(
      () => store.state.currentCue,
      newCue => {
        if (!htmlElement.value) {
          return;
        }
        if (newCue.id !== props.cue.id) {
          return;
        }
        htmlElement.value.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    );

    return {
      htmlElement,
      isInEditMode,
      isActive,
      onClick: () => {
        if (isInEditMode.value) {
          return;
        }

        // Add a small delta so that the tracklist selects the correct caption
        // if the user clicks on a subtitle that is timed too close to another one
        store.updateCurrentTimeEvent(
          props.cue.startTime + 0.0001,
          Origin.SubtitleElement
        );
      },
      updateCueText: (text: string) => {
        store.updateCueTextInCuesList(props.cue.id, text);

        if (store.state.currentCue.id !== props.cue.id) {
          return;
        }
        store.setCurrentCue(props.cue.id);
      },
      updateStartTime: (time: number) => {
        store.updateCueStartTimeInCuesList(props.cue.id, time);
      },
      updateEndTime: (time: number) => {
        store.updateCueEndTimeInCuesList(props.cue.id, time);
      }
    };
  }
});
